var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 3.72504C2.66667 4.05837 0 5.52504 0 8.72504C0 12.725 3 13.475 4.5 13.475H8.25011V9.47501H6.62429C6.37274 9.47501 6.23289 9.18403 6.39003 8.9876L8.76585 6.01783C8.88594 5.86771 9.11427 5.86771 9.23437 6.01783L11.6102 8.9876C11.7673 9.18403 11.6275 9.47501 11.3759 9.47501H9.75011V13.475H14C15.5 13.475 18 12.475 18 9.22504C18 6.47504 15.75 5.47504 14.5 5.47504C14.5 3.97504 13 0.475037 9 0.475037C5 0.475037 4 3.72504 4 3.72504Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.670e88045c9834515c51dd19ee3bf394.svg";
export { ForwardRef as ReactComponent };